import { render, staticRenderFns } from "./AlertSummary.vue?vue&type=template&id=8b86d5d4&"
import script from "./AlertSummary.vue?vue&type=script&lang=js&"
export * from "./AlertSummary.vue?vue&type=script&lang=js&"
import style0 from "./AlertSummary.vue?vue&type=style&index=0&id=8b86d5d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports